export default {
  "site.name": "AllChinaBuy Spreadsheet",
  "site.title": "AllChinaBuy Spreadsheet - Produkte, Verkäufer & Kaufanleitungen",
  "site.description": "Entdecken Sie AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Verkäufer-Recherche, QC-Anleitungen, Versandinformationen, Lager-Tipps und praktische Kaufanleitungen — organisiert in einem benutzerfreundlichen Ressourcen-Hub.",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Kategorien",
  "nav.guides": "Anleitungen",
  "nav.review": "Bewertung",
  "nav.shipping": "Versand",
  "nav.qc": "QC",
  "nav.safety": "Sicherheit",
  "nav.faq": "FAQ",
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",
  "hero.eyebrow": "ALLCHINABUY SPREADSHEET RESSOURCEN-CENTER",
  "hero.title": "AllChinaBuy Spreadsheet — Finden Sie Produkte, Verkäufer & Kaufanleitungen an Einem Ort",
  "hero.description": "Entdecken Sie AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Verkäufer-Recherche, QC-Anleitungen, Versandinformationen, Lager-Tipps und praktische Kaufanleitungen — organisiert in einem benutzerfreundlichen Ressourcen-Hub.",
  "hero.cta1": "AllChinaBuy Spreadsheet Erkunden",
  "hero.cta2": "Jetzt Kaufen",
  "hero.trust": "Unabhängige Ressource · Regelmäßig Aktualisiert · Mehrsprachig · Sicherheitsanleitungen",
  "categories.title": "Produktkategorien",
  "categories.description": "Durchsuchen Sie unsere kuratierten Produktkategorien und finden Sie genau das, was Sie auf AllChinaBuy Spreadsheet benötigen.",
  "categories.select": "Kategorie Auswählen",
  "articles.title": "AllChinaBuy Spreadsheet Anleitungen",
  "articles.description": "Umfassende Anleitungen und Ressourcen, die Ihnen helfen, die AllChinaBuy Spreadsheet-Erfahrung zu navigieren.",
  "articles.readMore": "Anleitung Lesen",
  "cta.title": "Bereit zum Einkaufen?",
  "cta.description": "Besuchen Sie die Hauptwebsite AllChinaBuy Spreadsheet, um Produkte zu erkunden, Preise zu vergleichen und mit Vertrauen zu kaufen.",
  "cta.mainSite": "AllChinaBuy Spreadsheet Besuchen",
  "cta.buyNow": "Jetzt Kaufen",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Kategorien",
  "footer.sellers": "Verkäufer",
  "footer.guides": "Anleitungen",
  "footer.review": "Bewertung",
  "footer.shipping": "Versand",
  "footer.qc": "QC",
  "footer.warehouse": "Lager",
  "footer.safety": "Sicherheit",
  "footer.resources": "Ressourcen",
  "footer.articles": "Artikel",
  "footer.faq": "FAQ",
  "footer.comparisons": "Vergleiche",
  "footer.company": "Unternehmen",
  "footer.about": "Über Uns",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.terms": "Nutzungsbedingungen",
  "footer.disclaimer": "AllChinaBuySpread ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website.",
  "footer.language": "Sprache",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.da": "Dansk",
  "article.published": "Veröffentlicht",
  "article.readTime": "Min. Lesezeit",
  "article.backToHome": "Zurück zur Startseite",
  "article.relatedArticles": "Verwandte Artikel",
  "article.tableOfContents": "Inhaltsverzeichnis",
  "whatIs.title": "Was ist AllChinaBuy Spreadsheet?",
  "whatIs.description": "AllChinaBuy Spreadsheet ist ein umfassendes Ressourcen-Center, das entwickelt wurde, um Käufern bei der Navigation in der komplexen Welt des internationalen Einkaufs zu helfen. Wir kuratieren Produktlisten, Verkäuferbewertungen, Versandanleitungen und Qualitätskontrollinformationen, um Ihr Einkaufserlebnis reibungslos und sicher zu gestalten.",
  "trust.title": "Warum AllChinaBuy Spreadsheet Vertrauen?",
  "trust.item1": "Unabhängige Ressource ohne Verbindung zu Verkäufern",
  "trust.item2": "Regelmäßig aktualisierte Produktkategorien und Preise",
  "trust.item3": "Mehrsprachiger Support für globale Käufer",
  "trust.item4": "Umfassende Sicherheits- und QC-Anleitungen",
  "seo.article1.title": "AllChinaBuy Spreadsheet Vollständige Anleitung",
  "seo.article1.desc": "Eine umfassende Anleitung zur Verwendung von AllChinaBuy Spreadsheet für Produktrecherche, Preisvergleich und die Suche nach vertrauenswürdigen Verkäufern.",
  "seo.article1.date": "August 2026",
  "seo.article1.readTime": "8",
};